import React, { useState } from "react";
import { Accordion, Image } from "react-bootstrap";
import FilterIcon from "../images/filter.svg";
import ResetIcon from "../images/rotate-left.svg";
import BreadCrumbHeader from "../customcomponents/BreadCrumbHeader";
import TextInputWithLabel from "../customcomponents/TextInputWithLabel";
import { FaRegTimesCircle } from "react-icons/fa";
import DocumentIcon from "../images/document.svg";

const emptyFilters = () => ({
  reference: "",
  status: "",
  dateFrom: "",
  dateTo: "",
  category: "",
  shipment: "",
  owner: "",
  priority: "",
});

const ClaimsFilterSidebar = ({
  close,
  handleFilterFun,
  partyFilterLabel = "Raised by",
  partyFilterPlaceholder = "Shipper, Platform…",
}) => {
  const [filterObj, setFilterObj] = useState(emptyFilters());

  const setField = (key, value) => {
    setFilterObj((prev) => ({ ...prev, [key]: value }));
  };

  const submit = () => {
    handleFilterFun({ ...filterObj });
    close();
  };

  const reset = () => {
    setFilterObj(emptyFilters());
    handleFilterFun({});
    close();
  };

  return (
    <>
      <div className="overlay_back" onClick={close} />
      <aside className="sidebar">
        <FaRegTimesCircle
          onClick={close}
          size={25}
          className="crossIcon"
          color="#E10404"
        />

        <div className="siderfilter">
          <div onClick={submit} style={{ cursor: "pointer" }}>
            <Image src={FilterIcon} alt="" /> <strong>Filters</strong>
          </div>
          <div onClick={reset} style={{ cursor: "pointer" }}>
            <Image src={ResetIcon} alt="" /> Reset
          </div>
        </div>

        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <BreadCrumbHeader image={DocumentIcon} title="CLAIM FILTERS" />
            </Accordion.Header>
            <Accordion.Body>
              <TextInputWithLabel
                label="Reference"
                type="text"
                placeholder="Enter reference"
                value={filterObj.reference}
                onChange={(e) => setField("reference", e.target.value)}
              />
              <TextInputWithLabel
                label="Status"
                type="text"
                placeholder="Pending, Resolved…"
                value={filterObj.status}
                onChange={(e) => setField("status", e.target.value)}
              />
              <TextInputWithLabel
                label="Date from"
                type="date"
                placeholder="DD/MM/YYYY"
                value={filterObj.dateFrom}
                onChange={(e) => setField("dateFrom", e.target.value)}
              />
              <TextInputWithLabel
                label="Date to"
                type="date"
                placeholder="DD/MM/YYYY"
                value={filterObj.dateTo}
                onChange={(e) => setField("dateTo", e.target.value)}
              />
              <TextInputWithLabel
                label="Category"
                type="text"
                placeholder="Damage, Loss…"
                value={filterObj.category}
                onChange={(e) => setField("category", e.target.value)}
              />
              <TextInputWithLabel
                label="Shipment"
                type="text"
                placeholder="Enter shipment number"
                value={filterObj.shipment}
                onChange={(e) => setField("shipment", e.target.value)}
              />
              <TextInputWithLabel
                label={partyFilterLabel}
                type="text"
                placeholder={partyFilterPlaceholder}
                value={filterObj.owner}
                onChange={(e) => setField("owner", e.target.value)}
              />
              <TextInputWithLabel
                label="Priority"
                type="text"
                placeholder="Low, Medium, High, Critical…"
                value={filterObj.priority}
                onChange={(e) => setField("priority", e.target.value)}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </aside>
    </>
  );
};

export default ClaimsFilterSidebar;
